import { styled } from 'styled-components';

export const StyledCompactTable = styled.div`
  table {
    border: 0 !important;
    margin: 0 !important;

    tbody {
      font-size: ${({ theme }) => theme.typography.headingLarge.fontSize};

      tr {
        color: ${({ theme }) => theme.colours.ink.primary.main};

        td {
          max-width: 245px !important;
          padding: ${({ theme }) => theme.sizing.small} !important;
          text-align: left;
          white-space: wrap;
          cursor: pointer;
        }

        &.active {
          td {
            background-color: ${({ theme }) =>
              theme.colours.interface.weak} !important;
            color: ${({ theme }) => theme.colours.interface.ink} !important;
          }
        }

        &.disabled {
          cursor: auto;
          pointer-events: none;

          td {
            color: ${({ theme }) =>
              theme.applyOpacity(
                theme.colours.ink.primary.main,
                'disabled',
              )} !important;
          }
        }
      }

      /* tr {
      td {
        height: 3rem;
        line-height: 1.3;
        padding: 5px 8px;
        cursor: pointer;
        transition: background 0.25s ease;
      }

      td + td {
        width: 50px;
        text-align: right;
      }
    } */
    }
  }
`;
